define.alias("shared/components/shared/social-identity/info", "calendar/components/shared/social-identity/info");